export function mailboxSuggestPayload() {
  // Backend resolves brokerage/company identity from the active parent account
  // (X-Account-Owner-Id). Do not send the concierge user's personal name.
  return {}
}

export function mailboxCreatePayload(email) {
  return { email }
}
